export default {
  sponsor_id: "number",
  sort_order: "number"
}
